// src/pages/Login/GoogleLoginButton.js
import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import * as jwtHandle from "../../core/Security/session-storage";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Config from '../../core/constants/Config';
import dataStore from "../../Store/store";
import { observer } from "mobx-react";
const GoogleLoginButton = observer(() => {

  const navigate = useNavigate();
  const handleSuccess = async (credentialResponse) => {
    try {
      // 1. Get the raw token (THE ONLY THING THE SERVER NEEDS)
      const googleToken = credentialResponse.credential;
  
      // 2. (Optional) Decode client-side for quick UI personalization
      const decoded = jwtDecode(googleToken);
       const email_verified = decoded.email_verified;
  
      // 3. Prepare the request body for your backend

      if (email_verified){
      const requestBody = {
        googleSubId: decoded.sub,
        email: decoded.email,
        firstName: decoded.given_name,
        lastName: decoded.family_name,
      };
  
      // 4. Send the token to your backend for verification and login/registration
      const response = await fetch(`${Config.local_public_endpoint}/emailLogin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
  
      if (!response.ok) {
        console.error("Google login failed:", response.statusText);
        return;
      }
  
      const json = await response.json();
  
      // 5. Store login data
      dataStore.setIsUserLogin(true);
      dataStore.setCustomerLogin(json);
  
     
      jwtHandle.setJwtToken(json.token);
      jwtHandle.setLoginResponse(json);
  
      // 6. Handle navigation logic
      const accountNumber = parseInt(dataStore.customerLogin?.account);
      localStorage.setItem("custId", dataStore.customerLogin?.custId);
  
      if (accountNumber === 1) {
        localStorage.setItem("isAdmin", dataStore.customerLogin?.isAdmin);
        const isAdmin = dataStore.customerLogin?.isAdmin === "true";
  
        if (isAdmin) {
        
          navigate("/admin-tabs");
        } else {
        
          navigate("/booking-tabs");
        }
      } else {
       
        navigate("/registrationForm");
      }
  
    }
    else{
      console.error("Google login failed not verified");
    }
   
    } catch (error) {
      console.error("Error during Google login:", error);
    }
 
  };
  


  const handleError = () => {
    console.error("Google login failed");
  };

  return (
    <div className="google-login-container">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        text="signin_with"
        shape="pill"
        width="280"
      />
    </div>
  );
});

export default GoogleLoginButton;
